import { render } from "./compliance.vue?vue&type=template&id=8d1b13a4&scoped=true&ts=true"
import script from "./compliance.vue?vue&type=script&lang=ts"
export * from "./compliance.vue?vue&type=script&lang=ts"

import "./compliance.vue?vue&type=style&index=0&id=8d1b13a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d1b13a4"]])

export default __exports__